<template>
  <div class="content ht-100v pd-0">
    <div ref="mainHeader" class="content-header bd-b pd-0">
      <nav class="navbar navbar-expand-lg wd-100p" style="height: 59px;">
        <a
          class="navbar-brand tx-spacing--2 order-1"
          data-toggle="dropdown"
          role="button"
        >
          Цэс & Эрхийн тохиргоо
        </a>
      </nav>
    </div>

    <div class="content-body pd-x-0 pd-y-0 overflow-hidden">
      <div class="container-fluid pd-x-0">
        <ag-grid-vue
          style="height: calc(100vh - 60px);"
          class="ag-theme-alpine wd-100p bd-0-f"
          :columnDefs="columnDefs"
          :defaultColDef="defaultColDef"
          :rowData="rowData"
          :frameworkComponents="frameworkComponents"
        >
        </ag-grid-vue>
      </div>
    </div>
  </div>
</template>

<script>
import { AgGridVue } from "ag-grid-vue";
// import {AllCommunityModules} from '@ag-grid-community/all-modules';
// import { AllModules } from '@ag-grid-enterprise/all-modules';

import { request } from "@/api/all";
import { hasOneOf } from "@/libs/tools";

import CheckboxCellRenderer from "./checkbox-cell-renderer.vue";

export default {
  components: {
    AgGridVue
  },
  data() {
    return {
      columnDefs: null,
      rowData: null,
      defaultColDef: null,
      frameworkComponents: null
    };
  },
  beforeMount() {
    this.defaultColDef = {
      flex: 1,
      minWidth: 200,
      editable: true,
      sortable: true,
      resizable: true
    };

    this.columnDefs = [
      {
        headerName: "Хэлтэс",
        field: "user.departName",
        pinned: "left",
        editable: false
      },
      {
        headerName: "Хэрэглэгч",
        field: "user.fullName",
        pinned: "left",
        editable: false
      }
      // { field: 'model' },
      // { field: 'price' }
    ];

    // this.rowData = [
    //     { make: 'Toyota', model: 'Celica', price: 35000 },
    //     { make: 'Ford', model: 'Mondeo', price: 32000 },
    //     { make: 'Porsche', model: 'Boxter', price: 72000 }
    // ];

    this.frameworkComponents = {
      checkboxRenderer: CheckboxCellRenderer
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    toggleBodyClass(addRemoveClass, className) {
      const el = document.body;

      if (addRemoveClass === "addClass") {
        el.classList.add(className);
      } else {
        el.classList.remove(className);
      }
    },
    init() {
      let self = this;

      this.toggleBodyClass("addClass", "dynamic-locker");
      request({
        api: { method: "GET", url: "Auth/GetRoles" },
        store: this.$store
      }).then(res => {
        this.toggleBodyClass("removeClass", "dynamic-locker");
        if (res != false) {
          let _distincted = res.data.roles
            .map(x => x.locTypeId)
            .filter((value, index, self) => self.indexOf(value) === index);
          //console.log(_distincted);
          let _groups = [];
          _distincted.forEach(g => {
            //console.log('g', res.data.roles.filter((x)=>x.locTypeId==g).length);
            _groups.push({
              headerName: res.data.roles.filter(f => f.locTypeId == g)[0]
                .locTypeName,
              showRowGroup: true,
              children: res.data.roles
                .filter(q => q.locTypeId == g)
                .map(w => {
                  return {
                    headerName: w.description,
                    field: "roles",
                    cellRenderer: "checkboxRenderer",
                    cellClass: params => {
                      return params.value === "user"
                        ? "bg-success"
                        : "bg-gray-100";
                    }
                  };
                })
              //           cellRenderer:'agGroupCellRenderer',
              //           cellRendererParams: {
              //     // turn off the row count
              //     suppressCount: true,
              //     // turn off double click for expand
              //     suppressDoubleClickExpand: true,
              //     // enable checkbox selection
              //     checkbox: true,
              //     // provide an inner renderer
              //     innerRenderer: myInnerRenderer,
              //     // provide a footer value getter
              //     footerValueGetter: myFooterValueGetter
              // }
            });
            // res.data.roles.filter((x)=>x.locTypeId==g).forEach(z => {
            //   console.log('z', z);
            //   _groups.push({ headerName: z.locTypeName, children: res.data.roles.filter(q=> q.locTypeId==z.locTypeId ).map((w)=>{ return{ headerName: w.description, filed: w.roleName } }) })
            // })
            // res.data.roles.filter((x)=>x.locTypeId==g).map((z)=>{
            //   return{ headerName: z.locTypeName, children: res.data.roles.filter(q=> q.locTypeId==z.locTypeId ).map((w)=>{ return{ headerName: w.description, filed: w.roleName } }) }
            // })
          });
          // _groups= res.data.roles.filter((x)=>_distincted.includes(x.locTypeId)).map((z)=>{
          //   return{ headerName: z.locTypeName, children: res.data.roles.filter(q=> q.locTypeId==z.locTypeId ).map((w)=>{ return{ headerName: w.description, filed: w.roleName } }) }
          // });
          //console.log('_groups', _groups);

          // let _prepared=[{
          //                   headerName: 'Үндсэн систем',
          //                   children: [
          //                       { headerName: 'Байгууллагын админ', field: 'admin' },
          //                       { field: 'user' },
          //                   ]
          //               },
          //               {
          //                   headerName: 'Сургалтын систем',
          //                   children: [
          //                       { field: 'learningstudent' },
          //                       { field: 'learningoffice', columnGroupShow: 'closed' },
          //                       { field: 'learningadmin', columnGroupShow: 'open' },
          //                       { field: 'silver', columnGroupShow: 'open' },
          //                       { field: 'bronze', columnGroupShow: 'open' },
          //                   ]
          //               }];

          //this.columnDefs= this.columnDefs.concat(res.data.roles.map((x)=>{ return { field: x.roleName } }));
          this.$nextTick(() => {
            this.columnDefs = this.columnDefs.concat(_groups);
          });
          //console.log(this.columnDefs);
          this.initAfter();
        }
      });
    },
    initAfter() {
      this.toggleBodyClass("addClass", "dynamic-locker");
      request({
        api: { method: "GET", url: "Role/GetUsersRoles" },
        store: this.$store
      }).then(res => {
        this.toggleBodyClass("removeClass", "dynamic-locker");
        if (res != false) {
          this.rowData = res.data.users;
          // .map((x)=>{
          //   console.log(x.user.fullName);
          //   name: x.user.fullName
          // });
          // console.log(res.data.users.map((x)=>{
          //   name: 'bat'
          // }));
          //console.log(res.data);
        }
      });
    }
  }
};
</script>

<style lang="scss">
@import "../../../../../node_modules/ag-grid-community/dist/styles/ag-grid.css";
@import "../../../../../node_modules/ag-grid-community/dist/styles/ag-theme-alpine.css";
</style>
